'use client';

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@repo/ui';
import { useLocale, useTranslations } from 'next-intl';
import { getLocaleMetadata, SUPPORTED_LOCALES, type SupportedLocaleType } from '@/i18n';
import { LocaleLink, useLocalePathname } from '@/lib/i18n/navigation';

export function LanguageSwitcherNav(): React.JSX.Element {
  const t = useTranslations('nav');
  const current = useLocale() as SupportedLocaleType;
  const pathname = useLocalePathname();
  const currentMeta = getLocaleMetadata(current);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t('ariaLanguageSwitcher')}
        className="flex h-11 items-center gap-1.5 rounded-lg px-3 text-base font-medium text-foreground hover:bg-accent/50"
      >
        <span aria-hidden>{currentMeta.flag}</span>
        <span className="text-xs uppercase tracking-wide">{current}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-44">
        {SUPPORTED_LOCALES.map((locale) => {
          const meta = getLocaleMetadata(locale);
          return (
            <DropdownMenuItem
              key={locale}
              asChild
              data-active={locale === current ? 'true' : undefined}
            >
              <LocaleLink
                href={pathname}
                locale={locale}
                hrefLang={locale}
                lang={locale}
                dir="ltr"
                className="flex min-h-11 items-center gap-2 py-1"
              >
                <span aria-hidden>{meta.flag}</span>
                <span className="flex-1 text-start">{meta.nativeName}</span>
                <span className="text-xs uppercase tracking-wide text-muted-foreground">
                  {locale}
                </span>
              </LocaleLink>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
